import { format, formatDistanceToNow, parseISO } from 'date-fns';
import { enUS, es, fr, it, pl } from 'date-fns/locale';

export type SupportedLocale = 'en' | 'pl' | 'fr' | 'es' | 'it';

const localeMap = { en: enUS, pl, fr, es, it } as const;

export function formatDate(iso: string, locale: SupportedLocale, pattern = 'PP'): string {
  return format(parseISO(iso), pattern, { locale: localeMap[locale] });
}

export function formatDateTime(iso: string, locale: SupportedLocale): string {
  return format(parseISO(iso), 'PPp', { locale: localeMap[locale] });
}

export function formatRelative(iso: string, locale: SupportedLocale): string {
  return formatDistanceToNow(parseISO(iso), { addSuffix: true, locale: localeMap[locale] });
}
